import {mapMutations} from "vuex";
import {SET_OBJECT_TO_ADD, SHOW_DIALOG} from "@/store/mutations.type";

/**
 * Adds showWatchlistDialog Method to any component to add the current log to a watchlist
 * <button @click="showWatchlistDialog">{{ $t('button.watch') }}</button>
 */
export default {
	methods: {
		...mapMutations([SET_OBJECT_TO_ADD, SHOW_DIALOG]),
		showWatchlistDialog(log, isVirtual) {
			this[SET_OBJECT_TO_ADD](log);
			this[SHOW_DIALOG]({
				component: 'WatchlistAdd',
				title: 'watchLog',
				contentClass: 'large-dialog',
				isVirtual
			});
		}
	}
}